<template>
  <div class="animated revealUp">
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('edit') }} {{ $t('supportticketcategory')}}</div>
      <router-link
        class="btn-blue"
        to="/master/support-ticket-category"
      >{{ $t('supportticketcategory') }} {{ $tc('list', 2) }}</router-link>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                v-model="category_name"
                v-validate="'required'"
                name="category_name"
                id="category_name"
                placeholder="."
                type="text"
              />
              <label>{{ $tc('category', 1) }} {{ $t('name') }}</label>
            </div>
            <Tooltip :title="$t('category_name')" />
          </div>
          <p class="error_message">
            <span
              v-if="submitted && errors.has('category_name')"
            >{{ errors.first('category_name') }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t('active') }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div class="col-4">
                <b-form-checkbox v-model="category_is_active" switch name="check-button"></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="onFinalSubmit(true)"
          >{{ $t('update') }}</button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="/master/support-ticket-category"
          >{{ $t('cancel') }}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      btenable: false,
      submitted: false,
      category_name: null,
      category_is_active: true,
      id: null
    };
  },
  beforeMount() {
    this.id = this.$route.query.stc_id;
    if (this.id) {
      this.GetSupportTicketCategory();
    } else {
      this.$router.go(-1);
    }
    this.onResetForm();
  },
  methods: {
    GetSupportTicketCategory: function() {
      let payload = {
        stc_id: this.id
      };
      let loader = this.$loading.show();

      MasterService.GetCategory(payload)
        .then(response => {
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              this.category_name = data.Records[0].stc_name;
              this.category_is_active =
                data.Records[0].stc_is_active == "Y" ? true : false;
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    onResetForm: function() {
      this.category_name = null;
      this.category_is_active = true;
    },
    onFinalSubmit: function(falg) {
      this.submitted = true;

      this.$validator.validate().then(valid => {
        if (valid) {
          this.btenable = true;

          let loader = this.$loading.show();

          let payload = {
            category_id: this.id,
            category_name: this.category_name,
            category_is_active: this.category_is_active
          };

          MasterService.UpdateCategory(payload)
            .then(response => {
              const { data } = response;
              this.btenable = false;

              if (data.status) {
                this.onResetForm();
                this.$toasted.show(data.message);
                this.$router.push({
                  path: "/master/support-ticket-category"
                });
                this.submitted = false;
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError)
            .finally(() => {
              setTimeout(() => loader.hide(), 1000);
            });
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/SupportTicketCategoryComponents/editSupportTicketCategory.vue